import { queryOptions } from '@tanstack/react-query';
import { fileDetailQueryFunction } from '@/modules/FileList/queries/fileDetail/fileDetailQueryFunction.ts';
import { FileDetailQueryParamsType } from '@/modules/FileList/queries/fileDetail/fileDetailQuery.type.ts';
import { fileDetailItemsGenerator } from '@/modules/FileList/data/FileDetailItems/fileDetailItemsGenerator.ts';

export const fileDetailQueryOption = ({ id }: FileDetailQueryParamsType) =>
  queryOptions({
    queryKey: ['my-files', 'file-detail', id],
    queryFn: () => fileDetailQueryFunction({ id }),
    select: (data) => ({
      fileType: data.file_type.const,
      relatedFilesNumber: data.related_file,
      detailCardItems: fileDetailItemsGenerator(data),
      insurance: data.insurance?.const,
    }),
  });
